import Privacy from "./privacy"
import Terms from "./terms"

export default {
    Privacy,
    Terms
}